
import Lottie from 'lottie-react';
import paymentLoader from '../../assets/animations/Payment loader.json';
import { Box, Typography } from '@mui/material';

export const PaymentLoader = () => {

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
            top: 0,
            left: 0,
            zIndex: 9999,
            position: 'fixed',
            backgroundColor: 'rgba(255, 255, 255, 0.3)', 
            backdropFilter: 'blur(2px)', 
            WebkitBackdropFilter: 'blur(2px)', 

        }}
        >
            <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center' }}>
                <Lottie
                    animationData={paymentLoader}
                    loop={true}
                    size={500}
                    style={{ height: '150px', width: '500px' }}
                />
            </div>
        </Box>
    );
};
